import { PaginationInfo } from '../shared';
import { graphqlApiWithPersisted } from './graphqlApi';

export interface IgdbGameSearchResult {
  id: number;
  name: string;
  coverUrl?: string;
  firstReleaseDate?: number;
}

export interface IgdbGameDetail {
  name: string;
  genres: string[];
  platforms: string[];
  summary?: string;
  storyline?: string;
  coverUrl?: string;
  websiteUrl?: string;
}

interface IgdbSearchGamesPayload {
  items: IgdbGameSearchResult[];
  pageInfo: Pick<PaginationInfo, 'hasNextPage' | 'page'>;
}

interface IgdbSearchGamesArgs {
  query: string;
  page?: number;
}

interface IgdbGameArgs {
  id: number;
}

interface IgdbSearchGamesResponse {
  data?: { fourPigDbSearchGames: { payload: IgdbSearchGamesPayload | null } };
}

interface IgdbGameResponse {
  data?: { fourPigDbGameById: { payload: IgdbGameDetail | null } };
}

const igdbApi = graphqlApiWithPersisted.injectEndpoints({
  endpoints: (builder) => ({
    fourPigDbSearchGames: builder.query<IgdbSearchGamesPayload, IgdbSearchGamesArgs>({
      query: ({ query, page }) => ({
        url: '/graphql/webapp?fourPigDbSearchGames',
        method: 'POST',
        body: {
          query: `query FourPigDbSearchGames($query: String!, $page: Int) {
            fourPigDbSearchGames(query: $query, page: $page) {
              payload {
                items {
                  id
                  name
                  coverUrl
                  firstReleaseDate
                }
                pageInfo {
                  page
                  hasNextPage
                }
              }
            }
          }`,
          variables: { query, page },
        },
      }),
      transformResponse: (response: IgdbSearchGamesResponse) =>
        response.data?.fourPigDbSearchGames.payload ?? {
          items: [],
          pageInfo: { page: 1, hasNextPage: false },
        },
    }),
    fourPigDbGameById: builder.query<IgdbGameDetail | null, IgdbGameArgs>({
      query: ({ id }) => ({
        url: '/graphql/webapp?fourPigDbGameById',
        method: 'POST',
        body: {
          query: `query FourPigDbGameById($id: Int!) {
            fourPigDbGameById(id: $id) {
              payload {
                name
                summary
                storyline
                coverUrl
                websiteUrl
                genres
                platforms
              }
            }
          }`,
          variables: { id },
        },
      }),
      transformResponse: (response: IgdbGameResponse) =>
        response.data?.fourPigDbGameById.payload ?? null,
    }),
  }),
});

export const { useLazyFourPigDbSearchGamesQuery, useLazyFourPigDbGameByIdQuery } = igdbApi;
